import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import LoginPage from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import TasksPage from "./pages/Tasks";
import TaskDetail from "./pages/TaskDetail";
import ExpensesPage from "./pages/Expenses";
import ExpenseApprovals from "./pages/ExpenseApprovals";
import AttendancePage from "./pages/Attendance";
import LeavesPage from "./pages/Leaves";
import LeaveApprovals from "./pages/LeaveApprovals";
import LiveRequestsPage from "./pages/LiveRequests";
import ProjectsPage from "./pages/Projects";
import UsersPage from "./pages/Users";
import AccountingPage from "./pages/Accounting";
import ActivityTypesPage from "./pages/ActivityTypes";

function Protected({ roles, children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-[#0B0C10] flex items-center justify-center text-slate-500 mono text-xs uppercase tracking-widest">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/tasks" element={<Protected><TasksPage /></Protected>} />
      <Route path="/tasks/:id" element={<Protected><TaskDetail /></Protected>} />
      <Route path="/expenses" element={<Protected><ExpensesPage /></Protected>} />
      <Route path="/approvals/expenses" element={<Protected roles={["manager", "admin"]}><ExpenseApprovals /></Protected>} />
      <Route path="/attendance" element={<Protected><AttendancePage /></Protected>} />
      <Route path="/leaves" element={<Protected><LeavesPage /></Protected>} />
      <Route path="/approvals/leaves" element={<Protected roles={["manager", "admin"]}><LeaveApprovals /></Protected>} />
      <Route path="/live-requests" element={<Protected><LiveRequestsPage /></Protected>} />
      <Route path="/projects" element={<Protected roles={["manager", "admin"]}><ProjectsPage /></Protected>} />
      <Route path="/users" element={<Protected roles={["admin"]}><UsersPage /></Protected>} />
      <Route path="/accounting" element={<Protected roles={["admin"]}><AccountingPage /></Protected>} />
      <Route path="/activity-types" element={<Protected roles={["admin"]}><ActivityTypesPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#13151A",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "2px",
              color: "white",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
